export const DEPARTURE_LOG_FILTER_DATA_CRITERIA = 37
